import './admin.scss';

document.addEventListener('DOMContentLoaded', function () {
	const menu = document.querySelector('#wp-admin-bar-apb_offer_menu');
	const wrap = document.querySelector('.wrap');
	const offerElement = document.createElement('div');
	const html = `<div class='bpl-admin-notice-wrap'>
		<div class='bpl-admin-notice bpl-promotion'>
			<div class='notice-content'>
				<div class='logo-wrap'>
					<div class='bpl-logo'>
						<img src='https://ps.w.org/advanced-post-block/assets/icon-128x128.png' />
					</div>
					<span class='bpl-icon bpl-icon-promotion'></span>
				</div>

				<div class='bpl-message'>
					<h3>Exclusive Cyber Monday Offer - Limited Time Only!</h3>
					<div>Upgrade your WordPress experience with <strong>Advanced Post Block Pro</strong> and save up to 40% during our biggest sale of the year!</div>
					<a href='edit.php?post_type=apb&page=apb-upgrade' class='bpl-btn bpl-btn-primary'>Save Big →</a>
				</div>

				<button class='bplPromoClose close-notice'>
					<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
						<path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z' />
					</svg>
				</button>
			</div>
		</div>
	</div>`;

	offerElement.appendChild(htmlToElement(html));

	wrap.insertAdjacentElement('afterbegin', offerElement);

	const closeEl = offerElement.querySelector('.bplPromoClose');

	const isClosed = localStorage.getItem('apbPromoClosed');

	if (isClosed) {
		offerElement.classList.add('hidden');
	}

	closeEl?.addEventListener('click', (e) => {
		e.preventDefault();
		offerElement.classList.toggle('hidden');

		localStorage.setItem('apbPromoClosed', true);
	});

	menu?.addEventListener('click', function (e) {
		e.preventDefault();
		offerElement.classList.toggle('hidden');
	});
});


function htmlToElement(html) {
	let temp = document.createElement('template');
	temp.innerHTML = html;
	return temp.content.firstChild;
}

export default htmlToElement;